// extracted by mini-css-extract-plugin
module.exports = {"container":"TablePreview_container__3vpbh","tableWrapper":"TablePreview_tableWrapper__2t8Na"};